import DOMPurify from 'dompurify';

const ACTIVITY_LOG_ALLOWED_TAGS = [
  'span',
  'strong',
  'a',
  'br',
  'p',
  'div',
] as const;

/**
 * Sanitize server-provided HTML before dangerouslySetInnerHTML.
 * Blocks scriptable SVG (inline script, foreignObject), scripts, and other XSS sinks.
 */
export function sanitizeActivityLogHtml(html: string): string {
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: [...ACTIVITY_LOG_ALLOWED_TAGS],
    ALLOWED_ATTR: ['href', 'class'],
    ALLOW_DATA_ATTR: false,
    FORBID_TAGS: [
      'script',
      'style',
      'iframe',
      'object',
      'embed',
      'foreignObject',
      'svg',
      'math',
    ],
    ALLOWED_URI_REGEXP:
      /^(?:(?:https?:)?\/\/|mailto:|tel:|#|\/|\.?\/)/i,
  });
}
